import { ICardElementWithChildren } from "backend/model/model";
import { PerformanceDonut } from "design/components/charts/PerformanceDonut";
import InitiativeHeading from "design/components/texts/InitiativeHeading";
import { getPropsFromContent, IDisplaySeries } from "design/types";
import React from "react";
import CardWrapper from "../InitiativeDetailsCardWrapper";
import useBudgetUtilizationCardStyles from "./BudgetUtilizationCardStyles";

type Props = {
  data: ICardElementWithChildren;
  display: IDisplaySeries;
  series: Array<IDisplaySeries>;
};

const BudgetUtilizationCard = (props: Props) => {
  const { data, display } = props;
  const classes = useBudgetUtilizationCardStyles();
  return (
    <div className={classes.container}>
      <InitiativeHeading>Budget Utilization</InitiativeHeading>

      <CardWrapper color="696969" period={data.period?.name || ""}>
        <div className={classes.card}>
          <PerformanceDonut
            colorKey={props.display.colorKey as any}
            element={data}
            prettyKey={display.prettyvalue as any}
            valueKey={display.value as any}
            neutralcolor={true}
          />
          <div className={classes.detailsSection}>
            {props.series.map((ser) => {
              const content = getPropsFromContent(data, ser);
              return (
                <div className={classes.budgetSection} key={content.title}>
                  <div className={classes.title}>{content.title}</div>
                  <div className={classes.value}>{content.prettyvalue}</div>
                </div>
              );
            })}
          </div>
        </div>
      </CardWrapper>
    </div>
  );
};

export default BudgetUtilizationCard;
